export default __webpack_public_path__ + "static/media/Hand_left.33dd1cd8.svg";